import { envLocale } from '@/constant/env';

export const locales = ['en', 'es', 'zh-cn'] as const;
export const defaultLocale = (envLocale as Locale) ?? 'en';
export type Locale = (typeof locales)[number];

export const localeBuildTogether: Locale[] = ['en', 'es'];
export const localeBuildSeparately: Locale[] = ['zh-cn'];

const dictionaries = {
  en: () =>
    import('../../../dictionaries/en.json').then((module) => module.default),
  'zh-cn': () =>
    import('../../../dictionaries/cn.json').then((module) => module.default),
  es: () =>
    import('../../../dictionaries/es.json').then((module) => module.default),
};

export async function getDictionary(locale: Locale) {
  return dictionaries[locale]();
}
